import { useLocation } from 'react-router';
import { useSessionStorage } from './useSessionStorage';

export function usePageSessionStorage<T>(
    key: string,
    initialValue: T,
): [T, (value: React.SetStateAction<T>) => void] {
    const location = useLocation();
    const sessionStoragePrefix = `StreamSix_${location.key}_${key}`;

    return useSessionStorage(sessionStoragePrefix, initialValue);
}
